export enum Typology {
  upstream = 'upstream',
  downstream = 'downstream',
  both = 'both',
  none = 'none'
}
